export default function (value: any): string {
  const formatter = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
  });
  return formatter.format(value);
}
